export const GET_EVENT_RULE_SUCCESS = 'GET_EVENT_RULE_SUCCESS';
export const GET_EVENT_RULE_ERROR = 'GET_EVENT_RULE_ERROR';

export const UPDATE_EVENT_RULE_SUCCESS = 'UPDATE_EVENT_RULE_SUCCESS';
export const UPDATE_EVENT_RULE_ERROR = 'UPDATE_EVENT_RULE_ERROR';